import request from '@/utils/request'

export function getNews(params) {
  return request({
    url: '/api/news',
    method: 'GET',
    params,
  })
}

export function getNewsDetail(id) {
  return request({
    url: `/api/news/${id}`,
    method: 'GET',
  })
}

export function createNews(data) {
  return request({
    url: '/api/news',
    method: 'POST',
    data
  })
}

export function editNews(id, data) {
  return request({
    url: `/api/news/${id}`,
    method: 'PUT',
    data
  })
}
